
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/sub-section",
      function () {
        return require("private-next-pages/sub-section/index.page.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/sub-section"])
      });
    }
  